import { render, staticRenderFns } from "./rich-text.mpx?vue&type=template&id=27e8b1ff&scoped=true&component=true&componentId=rich-text723effcf"
import script from "./rich-text.mpx?vue&type=script&lang=js&component=true&componentId=rich-text723effcf"
export * from "./rich-text.mpx?vue&type=script&lang=js&component=true&componentId=rich-text723effcf"
import style0 from "./rich-text.mpx?vue&type=style&index=0&id=27e8b1ff&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m723effcf%22%7D&component=true&componentId=rich-text723effcf"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e8b1ff",
  null
  
)

export default component.exports